import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { HeaderModule } from "../../_component/header/header.module";
import { PaginationClientSideModule } from "../_component/pagination-client-side/pagination-client-side.module";
import { SearchBarModule } from "../_component/search-bar/search-bar.module";
import { ListHeaderComponentModule } from "../_component/_structural/list-header/list-header.module";
import { BreadcrumbComponentModule } from "./../_component/breadcrumb/breadcrumb.module";
import { EditEquipmentModule } from "./edit-equipment/edit-equipment.module";
import { EquipmentPageRoutingModule } from "./equipment-routing.module";
import { EquipmentPage } from "./equipment.page";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    EquipmentPageRoutingModule,
    SearchBarModule,
    PaginationClientSideModule,
    TranslateModule,
    HeaderModule,
    EditEquipmentModule,
    BreadcrumbComponentModule,
    ListHeaderComponentModule,
  ],
  declarations: [EquipmentPage],
})
export class EquipmentPageModule {}
